import { render } from "./NavBarUser.vue?vue&type=template&id=120f0eec&scoped=true"
import script from "./NavBarUser.vue?vue&type=script&lang=js"
export * from "./NavBarUser.vue?vue&type=script&lang=js"

import "./NavBarUser.vue?vue&type=style&index=0&id=120f0eec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120f0eec"]])

export default __exports__